import React, { useCallback } from 'react';
import styles from './index.module.scss';
import { useStore, StoreTypes } from 'context';
import { EventBusType, EventBus } from 'events/EventBus';
import { ReaderToolsEvent } from 'events/EventTypes';

const eventBusType = EventBusType.ExtendedContent;

export const ExtendedAnswersButton = () => {

  const [{ isShowAnswer }] = useStore(StoreTypes.extendedContent);

  const changePopWindowAnswersHandler = useCallback(() => {
    EventBus.emit({
      eventBusType,
      event: ReaderToolsEvent.ChangePopWindowAnswersEvent,
      payload:{
        isShowAnswer:!isShowAnswer
      }
    });
  }, [isShowAnswer])

  return (
    <div className={styles.answersButton}>
      <div className={styles.answers} onClick={() => changePopWindowAnswersHandler()}>解答</div>
    </div>
  )
}
